export const translations = {
    en: {
        logout: "Logout",
        refreshData: "Refresh Data",
        refreshPage: "Refresh Page",
        home: "Home",
        hoursToStaySignedIn: "Hours to Stay Signed in",
        dataLastSynced: "Data Last Synced",
        online: "Online",
        offline: "Offline",
        newDailyFieldReport: "New Daily Field Report",
        drafts: "Drafts",
        pendingSubmissions: "Pending Submissions",
        submissions: "Last 30 Days Submissions",
        settings: "Settings",
        pending: "Pending",
        history: "History",
        view: "View",
        date: "Date",
        jobNumber: "Job Number",
        // workOrderNumber: "Work Order Number",
        notes: "Notes",
        job: "Job",
        workOrderNum: "Work Order #",
        rainedOut: "Rained Out",
        street1: "Street 1",
        street2: "Street 2",
        city: "City",
        state: "State",
        postalCode: "Postal Code",
        location: "Location",
        laborAndEquipment: "Labor and Equipment",
        employee: "Employee",
        position: "Position",
        driver: "Driver",
        startTime: "Start Time",
        endTime: "End Time",
        add: "Add",
        rows: "rows",
        laborLineItems: "Labor Line Items",
        standardEquipment: "Standard Equipment",
        equipment: "Equipment",
        quantity: "Quantity",
        additionalEquipment: "Additional Equipment",
        signOff: "Sign Off",
        foremanName: "Foreman Name",
        foremanSignature: "Foreman Signature",
        inspectorName: "Inspector Name",
        inspectorSignature: "Inspector Signature",
        getSignature: "Get Signature",
        cancel: "Cancel",
        clearSignature: "Clear Signature",
        saveSignature: "Save Signature",
        submit: "Submit",
        jobLocation: "Job Location",
        unsubmit: "Unsubmit",
        confirmLogout: "Are you sure you would like to logout?\n\nYou are not able to log back in without an internet connection.",
        clear: "Clear",
        version: "Version",
        getMostRecentAppVersion: "Get Most Recent App Version",
        summaryOfWorkCompleted: "Summary of Work Completed",
        typeOfEquipment: "Type of Equipment",
        serialNumber: "Serial Number",
        hours: "Hours",
        useLineItemsFromLastDFROnJob: "Use Line Items From Last DFR On Job",
        dragCornerToResize: "Drag the bottom-right corner to resize"
    },
    es: {
        logout: "Cerrar sesión",
        refreshData: "Actualizar datos",
        refreshPage: "Actualizar página",
        home: "Inicio",
        hoursToStaySignedIn: "Horas para permanecer conectado",
        dataLastSynced: "Datos sincronizados por última vez",
        online: "En línea",
        offline: "Sin conexión",
        newDailyFieldReport: "Nuevo informe diario de campo",
        drafts: "Borradores",
        pendingSubmissions: "Envíos pendientes",
        submissions: "Envíos de los Últimos 30 Días",
        settings: "Configuraciones",
        pending: "Pendiente",
        history: "Historial",
        view: "Ver",
        date: "Fecha",
        jobNumber: "Número de trabajo",
        notes: "Notas",
        job: "Trabajo",
        workOrderNum: "Orden de trabajo #",
        rainedOut: "Suspendido por lluvia",
        street1: "Calle 1",
        street2: "Calle 2",
        city: "Ciudad",
        state: "Estado",
        postalCode: "Código postal",
        location: "Ubicación",
        laborAndEquipment: "Mano de obra y equipo",
        employee: "Empleado",
        position: "Posición",
        driver: "Conductor",
        startTime: "Hora de inicio",
        endTime: "Hora de fin",
        add: "Añadir",
        rows: "filas",
        laborLineItems: "Elementos de línea de mano de obra",
        standardEquipment: "Equipo estándar",
        equipment: "Equipo",
        quantity: "Cantidad",
        additionalEquipment: "Equipo adicional",
        signOff: "Firmar",
        foremanName: "Nombre del capataz",
        foremanSignature: "Firma del capataz",
        inspectorName: "Nombre del inspector",
        inspectorSignature: "Firma del inspector",
        getSignature: "Obtener firma",
        cancel: "Cancelar",
        clearSignature: "Borrar firma",
        saveSignature: "Guardar firma",
        submit: "Enviar",
        jobLocation: "Ubicación del trabajo",
        unsubmit: "Desenviar",
        confirmLogout: "¿Está seguro de que desea cerrar sesión?\n\nNo podrá volver a iniciar sesión sin una conexión a Internet.",
        clear: "Borrar",
        version: "Versión",
        getMostRecentAppVersion: "Obtenga la versión más reciente de la aplicación",
        summaryOfWorkCompleted: "Resumen del trabajo completado",
        typeOfEquipment: "Tipo de equipo",
        serialNumber: "Número de serie",
        hours: "Horas",
        useLineItemsFromLastDFROnJob: "Usar elementos de línea del último DFR en el trabajo",
        dragCornerToResize: "Arrastre la esquina inferior derecha para cambiar el tamaño"
    }
};
